import { render, staticRenderFns } from "./tareas.vue?vue&type=template&id=8d71d282&scoped=true"
import script from "./tareas.vue?vue&type=script&lang=js"
export * from "./tareas.vue?vue&type=script&lang=js"
import style0 from "./tareas.vue?vue&type=style&index=0&id=8d71d282&prod&scoped=true&lang=css"
import style1 from "./tareas.vue?vue&type=style&index=1&id=8d71d282&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d71d282",
  null
  
)

export default component.exports